var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQnaPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 12v16a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4V12a4 4 0 0 1 4-4h3.028a4 4 0 0 0 3.578-2.211l.288-.578A4 4 0 0 1 15.472 3h5.056a4 4 0 0 1 3.578 2.211l.288.578A4 4 0 0 0 27.972 8H31a4 4 0 0 1 4 4zm-10 7a7 7 0 1 1-14 0 7 7 0 0 1 14 0zm-2.333 0a4.667 4.667 0 1 1-9.334 0 4.667 4.667 0 0 1 9.334 0z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQnaPhoto);
export default __webpack_public_path__ + "static/media/qna_photo.3ef2202235fcbef8f2534cdb2e2da81a.svg";
export { ForwardRef as ReactComponent };